import Helper from "./Helper";
import * as S from './../Vars/shares';

/**
 * Functions Shared Among the different Shares files
 * --------------------------------------------------
 * kinda like Helper, but specific, thus not cluttering Helper
 */
class SharesShared {
  constructor() {

  }

  static sort(order, filter) {
    let sort;
    let data;
    if (order == "alphabet") {
      data = "data-filter-alphabet";
      sort = ((a, b) => a.getAttribute(data).localeCompare(b.getAttribute(data)));
    } else {
      data = `data-${filter}`;
    }
    if (order == "ascending") {
      sort = (a, b) => a.getAttribute(data) - b.getAttribute(data);
    }
    if (order == "descending") {
      sort = (a, b) => b.getAttribute(data) - a.getAttribute(data);
    }
    const ordered = S.tiles.sort(sort);
    ordered.forEach((e, i) => {
      e.style.order = i;
    });
  }

  static getRange(upper, lower, steps) {
    const difference = upper - lower;
    const increment = difference / (steps - 1);
    return [lower, ...Array(steps - 2).fill('').map((_, index) =>
      lower + (increment * (index + 1))
    ), upper]
  }

  static formatNumString(num, decimalPoint, thousandsSep){
    num = Number.parseFloat(num).toFixed(1);
    return (
      num
        .toString()
        .replace('.', decimalPoint)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1'+thousandsSep)
    )
  }
}

export default SharesShared;
